// extracted by mini-css-extract-plugin
export default {"SidebarFooter":"SidebarFooter_SidebarFooter__bAQNQ","Button":"SidebarFooter_Button__rORY0"};